import CityPageTemplate from "../city-template/CityPageTemplate";
import { rioRanchoConfig } from "./data";

export default function RioRanchoPage() {
  return <CityPageTemplate config={rioRanchoConfig} />;
}